export function getLiterals(t: any) {
    return {
        header: {
            buttonLeft: t('header.buttonLeft'),
            buttonRight: t('header.buttonRight'),
            maintext: t('header.maintext'),
        },
        content: {
            welcome: t('content.welcome'),
            title: t('content.title'),
            main: t('content.main'),
            btnCreate: t('content.btnCreate'),
            haveAcount: t('content.haveAcount'),
            login: t('content.login')
        }
    }
}